/**
 * Appends a value to an array associated with a key in a Map.
 * If the key exists in the Map, the value is appended to the existing array.
 * If the key does not exist, a new array is created with the value.
 *
 * @template K - The type of keys in the Map.
 * @template T - The type of values stored in the arrays associated with the keys.
 * @param {Map<K, T[]>} map - The Map to which the value should be appended.
 * @param {K} key - The key to associate with the value.
 * @param {T[number]} value - The value to append to the array associated with the key.
 * @returns {Map<K, T[]>} The updated Map with the value appended to the array.
 */
export const appendToMap = <K, T extends unknown[]>(map: Map<K, T>, key: K, value: T[number]): Map<K, T> => {
	return new Map(map).set(key, map.has(key) ? ([...map.get(key)!, value] as T) : ([value] as T));
};
